import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export function PlanningQuotesTable({ quotes, onReload }) {
  const [editing, setEditing] = useState(null);
  const [busy, setBusy] = useState("");

  const saveEdit = async () => {
    setBusy("save");
    try {
      await api.patch(`/admin/planning-quote/${editing.id}`, { name: editing.name, email: editing.email });
      toast.success("Contact updated");
      setEditing(null);
      onReload();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    setBusy("");
  };

  const resend = async (q) => {
    if (!q.email) { toast.error("Add an email address first (Edit)."); return; }
    setBusy(`resend-${q.id}`);
    try {
      const r = await api.post(`/admin/planning-quote/${q.id}/resend`);
      toast.success(r.data.sent ? `Quote re-sent to ${r.data.email}` : "Email could not be delivered — check Resend settings.");
      onReload();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not resend"); }
    setBusy("");
  };

  return (
    <div className="overflow-x-auto border border-[#E5E7EB] bg-white" data-testid="planning-quotes-table">
      <table className="w-full text-sm">
        <thead className="bg-[#F4F4F4] text-left"><tr>{["Name", "Email", "Postcode", "Total", "Full plans", "Email sent", "Created", "Actions"].map(h => <th key={h} className="px-3 py-2 text-xs uppercase tracking-wider">{h}</th>)}</tr></thead>
        <tbody>
          {quotes.map(q => (
            <tr key={q.id} data-testid={`pq-row-${q.id}`} className="border-t border-[#E5E7EB] align-top">
              {editing && editing.id === q.id ? (
                <>
                  <td className="px-3 py-2"><input data-testid={`pq-edit-name-${q.id}`} value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} className="w-full border border-[#E5E7EB] px-2 py-1 text-sm" /></td>
                  <td className="px-3 py-2"><input data-testid={`pq-edit-email-${q.id}`} value={editing.email} onChange={e => setEditing({ ...editing, email: e.target.value })} className="w-full border border-[#E5E7EB] px-2 py-1 text-sm" /></td>
                </>
              ) : (
                <>
                  <td className="px-3 py-2">{q.name || "—"}</td>
                  <td className="px-3 py-2">{q.email || "—"}</td>
                </>
              )}
              <td className="px-3 py-2">{q.postcode || "—"}</td>
              <td className="px-3 py-2">£{Math.round(q.total_inc_vat || 0).toLocaleString("en-GB")}</td>
              <td className="px-3 py-2 text-xs">{q.has_full_plans ? "Yes" : "No"}</td>
              <td className="px-3 py-2 text-xs">{q.email_sent ? <span className="text-green-700 font-semibold">Sent</span> : <span className="text-[#6B7280]">—</span>}</td>
              <td className="px-3 py-2 text-xs text-[#6B7280]">{new Date(q.created_at).toLocaleString("en-GB")}</td>
              <td className="px-3 py-2 whitespace-nowrap">
                {editing && editing.id === q.id ? (
                  <div className="flex gap-3">
                    <button data-testid={`pq-save-${q.id}`} disabled={busy === "save"} onClick={saveEdit} className="text-xs font-bold uppercase tracking-widest text-[#C79A3B]">{busy === "save" ? "Saving…" : "Save"}</button>
                    <button data-testid={`pq-cancel-${q.id}`} onClick={() => setEditing(null)} className="text-xs font-bold uppercase tracking-widest text-[#6B7280]">Cancel</button>
                  </div>
                ) : (
                  <div className="flex gap-3">
                    <button data-testid={`pq-edit-${q.id}`} onClick={() => setEditing({ id: q.id, name: q.name || "", email: q.email || "" })} className="text-xs font-bold uppercase tracking-widest text-[#6B7280] hover:text-[#C79A3B]">Edit</button>
                    <button data-testid={`pq-resend-${q.id}`} disabled={busy === `resend-${q.id}`} onClick={() => resend(q)} className="text-xs font-bold uppercase tracking-widest text-[#C79A3B]">{busy === `resend-${q.id}` ? "Sending…" : "Resend"}</button>
                  </div>
                )}
              </td>
            </tr>
          ))}
          {quotes.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-[#6B7280]">No planning quotes yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
